import React from "react";

import NewsletterSlice from "../../components/slices/newsletter/NewsletterSlice";

const Newsletter = ({ slice }) => {
  return <NewsletterSlice slice={slice} />;
};

export default Newsletter;
